<!--
 * @Description: 常规工作/日常事务 拆班课
 * @Author: PF
 * @Date: 2022-12-28 15:57:15
 * @LastEditors: PF
 * @LastEditTime: 2025-06-18 11:59:32
-->
<template>
  <div>
    <el-dialog class="w1000 h700" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">拆班课</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <!-- 搜索区域 -->
      <el-row>
        <el-col :span="11">
          <el-container>
            <el-header>
              <div class="let_top_search">
                <el-select class="filter-item" v-model="selectxqid" placeholder="学期" @change="initBanJiList">
                  <el-option v-for="item in xqidList" :key="item.id" :label="item.xqmc" :value="item.id" />
                </el-select>
                <el-select class="filter-item" v-model="selectbjid" placeholder="班级" @change="initKeChengList">
                  <el-option v-for="item in bjidList" :key="item.id" :label="item.xzbmc" :value="item.id" />
                </el-select>
              </div>
            </el-header>
            <el-main>
              <el-table :data="leftTableData" style="width: 100%" border v-loading="loading" height="100%" @selection-change="leftSelectionChange" @row-dblclick="DTJinXingFenPeiRowDblclick">
                <el-table-column type="selection" align="center" width="55" />
                <el-table-column prop="xm" label="姓名" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-button type="primary" link @click="seeClick(scope.row)">{{ scope.row.xm }}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="xh" label="学号" align="center" show-overflow-tooltip />
                <el-table-column width="80" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-button type="primary" @click.stop="DTJinXingFenPeiClick(scope.row, scope.$index)">
                      <span class="iconfont icon-youjiantou"></span>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-col>
        <el-col :span="1">
          <div class="but_group">
            <span class="iconfont icon-shuangjiantouzuo" @click="PLQuXiaoFenPeiClick"></span>
            <span class="iconfont icon-shuangjiantouyou" @click="PLJinXingFenPeiClick"></span>
          </div>
        </el-col>
        <el-col :span="12">
          <el-container>
            <el-header>
              <div class="rig_top_search">
                <el-select class="filter-item" v-model="selectkcid" placeholder="拆班课" @change="initKeChengFenZuList">
                  <el-option v-for="item in keChengList" :key="item.kcid" :label="item.kcmc" :value="item.kcid" />
                </el-select>
              </div>
              <el-tabs v-model="selectkcfzid" class="demo-tabs" @tab-change="initRightList">
                <el-tab-pane v-for="item in keChengFenZuList" :key="item.id" :label="item.cbmc" :name="item.id"></el-tab-pane>
              </el-tabs>
            </el-header>
            <el-main>
              <div class="ke_cheng_fen_zu">
                <div v-for="item in keChengFenZuList" :key="item.id">
                  <div v-if="selectkcfzid === item.id">
                    <el-card shadow="never">
                      <div>授课教师：<span v-for="(val, i) in item.jss" :key="i"><span v-if="i!==0">、</span>{{val.jsxm}}</span></div>
                      <div>教学场地：<span v-for="(val, i) in item.jxcds" :key="i"><span v-if="i!==0">、</span>{{val.jxcdmc}}</span>
                      </div>
                    </el-card>
                  </div>
                </div>
              </div>
              <div class="xue_sheng_table">
                <el-table :data="rightTableData" style="width: 100%" border v-loading="loading" height="100%" @selection-change="rightSelectionChange" @row-dblclick="DTQuXiaoFenPeiRowDblclick">
                  <el-table-column type="selection" align="center" width="55" />
                  <el-table-column width="80" align="center" show-overflow-tooltip>
                    <template #default="scope">
                      <el-button type="primary" @click.stop="DTQuXiaoFenPeiClick(scope.row, scope.$index)">
                        <span class="iconfont icon-zuojiantou"></span>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column prop="xsxm" label="姓名" align="center" show-overflow-tooltip>
                    <template #default="scope">
                      <el-button type="primary" link @click="seeClick(scope.row)">{{ scope.row.xsxm }}</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column prop="xsxh" label="学号" align="center" show-overflow-tooltip />
                </el-table>
              </div>
            </el-main>
          </el-container>
        </el-col>
      </el-row>
    </el-dialog>
    <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
    <!-- 办理 弹窗 结束 -->
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadSelect, actionPost, actionDelete, homeCloseWindow } from '@/api/common.js'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import detail from '@/components/xuesheng/detail'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 搜索
const selectxqid = ref() // 学期ID
const selectbjid = ref() // 班级ID
const xqidList = ref([]) // 学期列表
const bjidList = ref([]) // 班级列表
const selectxqmc = ref() // 学期名称

const selectkcid = ref() // 课程ID
const selectkcfzid = ref() // 课程分组ID

const keChengList = ref([]) // 课程列表
const keChengFenZuList = ref([]) // 课程分组列表

const selectcbkbs = ref([]) // 拆班课标识
const selectcbmc = ref([]) // 拆班名称

const loading = ref(false)
const leftTableData = ref([]) // 左侧列表
const rightTableData = ref([]) // 右侧列表
const leftXuanZhong = ref([]) // 左侧列表选中
const rightXuanZhong = ref([]) // 右侧列表选中
const leftMultipleSelection = ref([]) // 左侧多选
const rightMultipleSelection = ref([]) // 右侧多选

const row = ref()
const openDetail = ref(false)

// 单击进行分班
const DTJinXingFenPeiClick = (row, index) => {
  leftXuanZhong.value.unshift(row)
  leftMultipleSelection.value = []
  rightMultipleSelection.value = []
  rightTableData.value.unshift(row)
  leftTableData.value.splice(index, 1)
  jinXingFenPeiTiJiao()
}
// 单击取消分班
const DTQuXiaoFenPeiClick = (row, index) => {
  leftMultipleSelection.value = []
  rightMultipleSelection.value = []
  leftTableData.value.unshift(row)
  rightTableData.value.splice(index, 1)
  quXiaoFenPeiTiJiao()
}
// 双击进行分班
const DTJinXingFenPeiRowDblclick = (row) => {
  leftMultipleSelection.value = []
  rightMultipleSelection.value = []
  leftMultipleSelection.value.push(row)
  PLJinXingFenPeiClick()
}
// 双击取消分班
const DTQuXiaoFenPeiRowDblclick = (row) => {
  leftMultipleSelection.value = []
  rightMultipleSelection.value = []
  rightMultipleSelection.value.push(row)
  PLQuXiaoFenPeiClick()
}
// 批量进行分班
const PLJinXingFenPeiClick = () => {
  if (leftMultipleSelection.value.length) {
    leftMultipleSelection.value.forEach((element) => {
      leftXuanZhong.value.unshift(element)
      rightTableData.value.unshift(element)
      leftTableData.value.forEach((e, index) => {
        if (e.id === element.id) {
          leftTableData.value.splice(index, 1)
        }
      })
    })
    leftMultipleSelection.value = []
    jinXingFenPeiTiJiao()
  }
}
// 批量取消分班
const PLQuXiaoFenPeiClick = () => {
  if (rightMultipleSelection.value.length) {
    rightMultipleSelection.value.forEach((element) => {
      leftTableData.value.unshift(element)
      rightTableData.value.forEach((e, index) => {
        if (e.id === element.id) {
          rightTableData.value.splice(index, 1)
        }
      })
    })
    rightMultipleSelection.value = []
    quXiaoFenPeiTiJiao()
  }
}
// 进行分班提交
const jinXingFenPeiTiJiao = async () => {
  const ids = []
  leftXuanZhong.value.forEach((element) => {
    ids.push(element.id)
  })
  const obj = {
    xsids: ids, // 学生ID
    xqid: selectxqid.value || '', // 学期ID
    bjid: selectbjid.value || '', // 班级ID
    kcid: selectkcid.value || '', // 课程ID
    cbkbs: selectcbkbs.value, // 拆班课标识
    cbmc: selectcbmc.value // 拆班名称
  }
  qingKong()
  const o = { url: '/api/v2/jiaowu/chaibanke/xuesheng', data: obj }
  actionPost(o).then((res) => {
    initLeftList()
    initRightList()
    if (res.code === 200) {
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 取消分班提交
const quXiaoFenPeiTiJiao = async () => {
  const ids = []
  leftTableData.value.forEach((element) => {
    ids.push(element.id)
  })
  const o = { url: '/api/v2/jiaowu/chaibanke/xuesheng', data: { ids } }
  actionDelete(o).then((res) => {
    initLeftList()
    initRightList()
    if (res.code === 200) {
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 左侧复选框
const leftSelectionChange = (val) => {
  leftMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      leftMultipleSelection.value.push(element)
    })
  }
}
// 右侧复选框
const rightSelectionChange = (val) => {
  rightMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      rightMultipleSelection.value.push(element)
    })
  }
}
// 清空选中
const qingKong = () => {
  leftXuanZhong.value = []
  rightXuanZhong.value = []
}
// 左侧列表
const initLeftList = async () => {
  loading.value = true
  const obj = {
    bjid: selectbjid.value || '', // 班级ID
    cbkbs: selectcbkbs.value, // 拆班课标识
    cbmc: selectcbmc.value // 拆班名称
  }
  const o = { url: '/api/v2/jiaowu/chaibanke/weifenpeixuesheng', data: obj }
  actionPost(o).then((res) => {
    loading.value = false
    if (res.code === 200) {
      leftTableData.value = res.data || []
    } else {
      warningPrompt(res.message)
    }
  })
}
// 右侧列表
const initRightList = async (val) => {
  loading.value = true
  keChengFenZuList.value.forEach((element) => {
    if (element.id === val) {
      selectcbkbs.value = element.cbkbs // 拆班课标识
      selectcbmc.value = element.cbmc // 拆班名称
    }
  })
  const obj = {
    cbkbs: selectcbkbs.value, // 拆班课标识
    cbmc: selectcbmc.value // 拆班名称
  }
  const o = { url: '/api/v2/jiaowu/chaibanke/xueshenglist', data: obj }
  actionPost(o).then((res) => {
    loading.value = false
    if (res.code === 200) {
      rightTableData.value = res.data || []
    } else {
      warningPrompt(res.message)
    }
  })
}
// 班级列表
const initBanJiList = async () => {
  const o = { url: '/api/v2/pdp/banji/banzhuren', data: { xqid: selectxqid.value } }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      bjidList.value = res.data
      selectbjid.value = res.data.length === 0 ? '' : res.data[0].id
      initKeChengList()
    } else {
      warningPrompt(res.message)
    }
  })
}
// 课程列表
const initKeChengList = () => {
  const obj = {
    xqid: selectxqid.value || '', // 学期ID
    bjid: selectbjid.value || '' // 班级ID
  }
  const o = { url: '/api/v2/jiaowu/chaibanke/kecheng', data: obj }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      keChengList.value = res.data
      selectkcid.value = res.data.length === 0 ? '' : res.data[0].kcid
      initKeChengFenZuList()
    } else {
      warningPrompt(res.message)
    }
  })
}
// 课程分组列表
const initKeChengFenZuList = () => {
  const obj = {
    xqid: selectxqid.value || '', // 学期ID
    bjid: selectbjid.value || '', // 班级ID
    kcid: selectkcid.value || '' // 课程ID
  }
  const o = { url: '/api/v2/jiaowu/chaibanke/list', data: obj }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      keChengFenZuList.value = res.data
      selectkcfzid.value = res.data.length === 0 ? '' : res.data[0].id
      selectcbkbs.value = res.data.length === 0 ? '' : res.data[0].cbkbs
      selectcbmc.value = res.data.length === 0 ? '' : res.data[0].cbmc
      initLeftList()
    } else {
      warningPrompt(res.message)
    }
  })
}
// 下拉列表
const initSelectList = async () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: xqidList,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq) {
          selectxqid.value = element.id
          selectxqmc.value = element.xqmc
          initBanJiList()
        }
      })
    }
  })
}

const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'chaibanke') {
      openList.value = true
      initSelectList()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.el-dialog__body) {
  height: calc(100% - 55px);
  .el-row,
  .el-col {
    height: 100%;
  }
}
.search {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  .filter-item {
    width: calc(30% - 20px);
    margin-right: 10px;
  }
}
.let_top_search {
  margin-bottom: 5px;
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: space-between;
  .filter-item {
    margin-bottom: 10px;
  }
  .el-select,
  .el-button {
    width: 100%;
  }
}
:deep(.el-tabs__content) {
  display: none;
}
.el-tabs {
  height: 55px;
}
.footer {
  margin-top: 20px;
  display: flex;
  div {
    margin-right: 10px;
    display: flex;
    align-items: flex-end;
  }
}
.left_footer {
  h2 {
    color: #f56c6c;
    margin-right: 5px;
  }
}
.right_footer {
  h2 {
    color: #95d475;
    margin-right: 5px;
  }
}
:deep(.but_group) {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  .iconfont {
    font-size: 1.5rem;
    cursor: pointer;
  }
}
.ke_cheng_fen_zu {
  height: 90px;
  margin-bottom: 10px;
  .fen_zu_cont,
  .el-card,
  :deep(.el-card__body) {
    height: 100%;
  }
}
.xue_sheng_table {
  height: calc(100% - 100px);
}

:deep(.el-tabs__active-bar) {
  min-width: 50px;
}
:deep(.el-tabs__item) {
  padding: 0;
  min-width: 50px;
  text-align: center;
}
</style>
